import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
function toPercent(num) {
  if (num <= 0) return '100%';
  if (num < 1) return "".concat(num * 100, "%");
  return "".concat(num, "%");
}
var Ratio = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    children = _ref.children,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? '1x1' : _ref$aspectRatio,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "children", "aspectRatio", "style"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'ratio');
  var isCustomRatio = typeof aspectRatio === 'number';
  return /*#__PURE__*/_jsx("div", _objectSpread({
    ref: ref
  }, props, {
    style: _objectSpread({}, style, isCustomRatio && {
      '--bs-aspect-ratio': toPercent(aspectRatio)
    }),
    className: classNames(bsPrefix, className, !isCustomRatio && "".concat(bsPrefix, "-").concat(aspectRatio)),
    children: React.Children.only(children)
  }));
});
export default Ratio;